<template>
    <div v-if="videoSrc" style='position:fixed;top:0;bottom:0;right:0;left:0;z-index:999;background-color:#000;'>
        <video id="videoEle" :src="videoSrc" @ended="videoEnded" autoplay="true" controls style='width:100%;height:100%;'></video>
    </div>
  </template>
  
  <script>
  import cookie from 'js-cookie';
  export default {
    data () {
      return {
        videoSrc:"",
        isover:false
      }
    },
    computed: {
        
    },
    created:function(){
        this.isover = false;
        this.videoSrc = cookie.get("videoUrl")
    },
    methods: {
      /**
     * 视频播放结束钩子
     */
     videoEnded() {
       if(!this.isover){
        this.isover = true;
        console.error("播放结束")
        this.$router.go(-1);
       }
       
    }
    },
    destroyed(){
        this.videoSrc = ""
        cookie.set("videoUrl","")
    }
  }
  </script>
  


// WEBPACK FOOTER //
// src/components/videoPlay.vue